import { clsx } from 'clsx';
import { forwardRef } from 'react';

import type { ProductReviewsViewModel } from '@jane/bloom/viewModels/productReviews';

import { ProductReviews } from './productReviews';
import { ProductReviewsSummary } from './productReviewsSummary';

import styles from './productReviewsSection.module.css';

interface ProductReviewSectionProps {
  productIdentifiers: {
    id: number;
    slug?: string;
  };
  productReviewsViewModel: ProductReviewsViewModel;
}

export const ProductReviewsSection = forwardRef<
  HTMLDivElement,
  ProductReviewSectionProps
>(function ProductReviewsSection(
  { productIdentifiers: { id, slug }, productReviewsViewModel },
  ref
) {
  if (!productReviewsViewModel.summary.hasReviews) {
    return null;
  }

  const productRatings =
    productReviewsViewModel.summary.productReviewsFacets.rating;

  return (
    <div ref={ref} className={styles['pdpReviewsSection']}>
      <div className={styles['pdpSection']}>
        <ProductReviewsSummary
          aggregateRating={productReviewsViewModel.summary.aggregateRating}
          reviewCount={productReviewsViewModel.summary.totalReviewCount}
          reviewPercentages={productRatings}
        />
      </div>

      <div
        className={clsx(styles['pdpSection'], styles['pdpReviewsListSection'])}
      >
        <ProductReviews
          initialPagination={productReviewsViewModel.pagination}
          initialReviews={productReviewsViewModel.reviews}
          productId={id}
          productSlug={slug}
          reviewCount={productReviewsViewModel.summary.reviewCountWithComments}
        />
      </div>
    </div>
  );
});
